import clsx from "clsx";

import type { ISettingButtonProps } from "../..";

import classes from "./styles.module.scss";

import { Icon } from "@components/atoms/icons";

export function SettingButton({ size, onClick, icon }: ISettingButtonProps) {
  return (
    <button
      type={"button"}
      onClick={() => onClick?.()}
      className={clsx(
        classes.settingButton,
        size === "big" && classes.settingButton__sizeBig,
      )}
    >
      <Icon name={icon} color={"primary-text"} fontSize={"xl"} />
    </button>
  );
}
